// Sample Able Assess screenings for the demo client. Shaped like the
// `/able-care/clients/:id/measurements` response, which stores the webhook
// payload as-is: grip in kg with per-hand `values`, `atRisk` straight from Able.
//
// Four quarterly screenings for a woman in her late 70s whose strength and gait
// slip from "not at risk" to "at risk of falls" — enough to exercise every state
// the panel can show.

// Clients the sample is shown for: by any of their ids (route param, Mongo _id
// or client number), or by "first last" (lower-case).
export const ABLECARE_SAMPLE_CLIENT_IDS = new Set(["4403"]);
export const ABLECARE_SAMPLE_CLIENT_NAMES = new Set(["bill hess"]);

// Used for STEADI banding only when the client record has no DOB or sex.
export const SAMPLE_INDIVIDUAL = { age: 78, sex: "female" };

const SENSOR = "FLEX000123";

const daysAgo = (n, hour = 10) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  d.setHours(hour, 15, 0, 0);
  return d.toISOString();
};

const SCREENINGS = [
  // [daysAgo, gripL, gripR, gripRisk, cst, cstRisk, gst, gstRisk, tug, tugRisk]
  [272, 21.4, 22.8, false, 13, false, 0.98, false, 10.6, false],
  [181, 20.6, 22.1, false, 12, false, 0.91, false, 11.2, false],
  [92, 19.1, 20.3, false, 10, false, 0.83, false, 11.9, false],
  [6, 17.2, 18.6, true, 9, true, 0.74, true, 13.4, true],
];

const buildScreening = ([ago, gl, gr, gripRisk, cst, cstRisk, gst, gstRisk, tug, tugRisk], i) => {
  const screeningId = `scrn_sample${String(i + 1).padStart(2, "0")}`;
  const at = daysAgo(ago);
  const m = (code, type, result, unit, atRisk, values = []) => ({
    ableMeasurementId: `msmt_sample${i + 1}_${code}`,
    ableScreeningId: screeningId,
    sensorId: SENSOR,
    type,
    result,
    unit,
    atRisk,
    values,
    measuredAt: at,
  });
  const measurements = [
    m("g", "SMGT", Math.max(gl, gr), "kg", gripRisk, [
      { hand: "LEFT", result: gl, unit: "kg" },
      { hand: "RIGHT", result: gr, unit: "kg" },
    ]),
    m("c", "CST", cst, "reps", cstRisk),
    m("s", "GST", gst, "m/s", gstRisk),
    m("t", "TUG", tug, "s", tugRisk),
  ];
  return {
    screening: {
      ableScreeningId: screeningId,
      sensorId: SENSOR,
      type: "FALLS",
      atRisk: measurements.some((x) => x.atRisk === true),
      screenedAt: at,
    },
    measurements,
  };
};

export function buildAbleCareSample() {
  const built = SCREENINGS.map(buildScreening).reverse(); // newest first
  return {
    screenings: built.map((b) => b.screening),
    measurements: built.flatMap((b) => b.measurements),
  };
}
